/* import __COLOCATED_TEMPLATE__ from './fullscreen-table.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();